(function () {
  'use strict';

  if (window.innerWidth > 767) return;

  var footer = document.querySelector('.abk-sticky-footer');
  if (!footer) return;

  var pageType = footer.dataset.footerType;
  var qs = function (s) { return document.querySelector(s); };
  var qsa = function (s) { return document.querySelectorAll(s); };

  /* ── Header hide/show on scroll ── */
  (function () {
    var lastY = window.scrollY, ticking = false, threshold = 60;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          var y = window.scrollY;
          if (y > threshold) {
            if (y > lastY + 8) document.body.classList.add('abk-header-hidden');
            else if (y < lastY - 8) document.body.classList.remove('abk-header-hidden');
          } else {
            document.body.classList.remove('abk-header-hidden');
          }
          lastY = y; ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

/* ── Active state tracking ── */
var _activeAction = null; /* tracks which action is currently open */

function setActiveBtn(action){
  footer.querySelectorAll('.abk-footer-item').forEach(function(el){el.classList.remove('is-active');});
  if(action){
    var btn=footer.querySelector('[data-abk-action="'+action+'"]');
    if(btn)btn.classList.add('is-active');
    _activeAction=action;
  }else{
    _activeAction=null;
  }
}

/* Close all open panels except the one being opened */
function closeAllExcept(keep){
  /* Close search */
  if(keep!=='search'){
    var sc=qs('.site-header__search-container');
    if(sc&&sc.classList.contains('is-active')){
      sc.classList.remove('is-active');
      document.dispatchEvent(new CustomEvent('predictive-search:close',{bubbles:true}));
    }
  }
  /* Close menu */
  if(keep!=='menu'){
    var mn=qs('.mobile-nav-wrapper,.mobile-nav,.nav-bar--is-open');
    if(mn&&(mn.classList.contains('is-open')||mn.classList.contains('mobile-nav--is-open'))){
      var trigger=qs('.mobile-nav-trigger');
      if(trigger)trigger.click();
    }
  }
  /* Close account */
  if(keep!=='account'){
    var m=qs('breeze-login-module');
    if(m){
      var cs=getComputedStyle(m);
      var open=m.hasAttribute('open')||m.classList.contains('open')||m.classList.contains('is-open')||m.classList.contains('is-active')||cs.display==='block';
      if(open){
        if(typeof window.closeBreezeLoginModal==='function'){window.closeBreezeLoginModal();}
        else{var cb=m.querySelector('[class*="close"],[aria-label*="close"],[aria-label*="Close"]');if(cb)cb.click();}
      }
    }
  }
}

/* Deals page auto-highlight */
if(window.location.pathname.indexOf('special-offers-deals')>-1){
  var d=footer.querySelector('.abk-deals-btn');
  if(d)d.classList.add('is-active');
}


  /* ── Deals page auto-highlight ── */
  if (window.location.pathname.indexOf('special-offers-deals') > -1) {
    var d = footer.querySelector('.abk-deals-btn');
    if (d) d.classList.add('is-active');
  }

  /* ── Cart count ── */
  function updateCartCount(n) {
    qsa('.abk-cart-count').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-hidden', !n);
    });
  }
  function fetchCartCount() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCartCount(c.item_count); })
      .catch(function () {});
  }

/* ── Search ── */
function doSearch(e){
  e.stopPropagation();
  var c=qs('.site-header__search-container');
  if(!c)return;
  /* Toggle: if already open, close it */
  if(c.classList.contains('is-active')){
    c.classList.remove('is-active');
    document.dispatchEvent(new CustomEvent('predictive-search:close',{bubbles:true}));
    setActiveBtn(null);
    return;
  }
  /* Close everything else first */
  closeAllExcept('search');
  c.classList.add('is-active');
  document.dispatchEvent(new CustomEvent('predictive-search:open',{detail:{context:'header'},bubbles:true}));
  var inp=c.querySelector('input[type="search"]');
  if(inp)setTimeout(function(){inp.focus();},50);
  setActiveBtn('search');
  /* Inject close X into search container if not already there */
  if(!c.querySelector('.abk-search-close')){
    var xBtn=document.createElement('button');
    xBtn.className='abk-search-close';
    xBtn.setAttribute('aria-label','Close search');
    xBtn.setAttribute('type','button');
    xBtn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    xBtn.style.cssText='position:absolute;top:50%;right:12px;transform:translateY(-50%);background:none;border:none;cursor:pointer;padding:6px;color:#111;z-index:10;display:flex;align-items:center;justify-content:center;';
    xBtn.addEventListener('click',function(ev){ev.stopPropagation();doSearch(ev);});
    c.style.position='relative';
    c.appendChild(xBtn);
  }
  /* Also deactivate search highlight when search closes externally */
  var searchObserver=new MutationObserver(function(){
    if(!c.classList.contains('is-active'))setActiveBtn(null);
  });
  searchObserver.observe(c,{attributes:true,attributeFilter:['class']});
}


/* ── Menu ── */
function doMenu(){
  /* Toggle: check if menu is currently open */
  var mn=qs('.mobile-nav-wrapper,.mobile-nav');
  var isOpen=mn&&(mn.classList.contains('is-open')||mn.classList.contains('mobile-nav--is-open')||mn.style.display==='block');
  if(isOpen){
    var trigger=qs('.mobile-nav-trigger');
    if(trigger)trigger.click();
    setActiveBtn(null);
    return;
  }
  /* Close everything else first */
  closeAllExcept('menu');
  var el=qs('.mobile-nav-trigger');
  if(el)el.click();
  setActiveBtn('menu');
  /* Watch for menu closing externally (e.g. user taps outside) */
  if(mn){
    var menuObserver=new MutationObserver(function(){
      var stillOpen=mn.classList.contains('is-open')||mn.classList.contains('mobile-nav--is-open');
      if(!stillOpen&&_activeAction==='menu')setActiveBtn(null);
    });
    menuObserver.observe(mn,{attributes:true,attributeFilter:['class','style']});
  }
}

  /* ── Account ── */
  function doAccount() {
    var m = qs('breeze-login-module');
    if (m) {
      var cs = getComputedStyle(m);
      var open = m.hasAttribute('open') || m.classList.contains('open')
        || m.classList.contains('is-open') || m.classList.contains('is-active')
        || cs.display === 'block' || cs.visibility === 'visible';
      if (open) {
        if (typeof window.closeBreezeLoginModal === 'function') { window.closeBreezeLoginModal(); return; }
        var cb = m.querySelector('[class*="close"],[aria-label*="close"],[aria-label*="Close"]');
        if (cb) { cb.click(); return; }
      }
    }
    if (typeof window.openBreezeLoginModal === 'function') { window.openBreezeLoginModal(); return; }
    var el = qs('.kavachLoginAccountLogo');
    if (el && el.style.display !== 'none') { el.click(); return; }
    var fb = qs('.shopifyLoginAccountLogo');
    if (fb) fb.click();
  }

  /* ── Cart ── */
  function doCart() {
    document.dispatchEvent(new CustomEvent('cart:open'));
    var el = qs('#HeaderCartTrigger');
    if (el) el.click();
  }

  /* ── Filter ── */
  function doFilter() {
    var btn = qs('.collection-filter__btn');
    if (btn) btn.click();
  }

  /* ── Sort popup ── */
  var sortPopupBuilt = false;
  function buildSortPopup() {
    if (sortPopupBuilt) return;
    sortPopupBuilt = true;
    var raw = document.querySelectorAll('.collection-sidebar__group--sort .filter-sort');
    if (!raw.length) raw = document.querySelectorAll('.filter-sort');
    var seen = {}, btns = Array.from(raw).filter(function (b) {
      if (seen[b.dataset.value]) return false;
      seen[b.dataset.value] = true; return true;
    });
    if (!btns.length) return;

    var overlay = document.createElement('div');
    overlay.className = 'abk-sort-overlay';
    overlay.addEventListener('click', closeSortPopup);

    var popup = document.createElement('div');
    popup.className = 'abk-sort-popup';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-label', 'Sort options');

    var hdr = document.createElement('div');
    hdr.className = 'abk-sort-popup__header';
    var ttl = document.createElement('p');
    ttl.className = 'abk-sort-popup__title'; ttl.textContent = 'Sort By';
    var cls = document.createElement('button');
    cls.className = 'abk-sort-popup__close'; cls.setAttribute('aria-label', 'Close');
    cls.textContent = '✕'; cls.addEventListener('click', closeSortPopup);
    hdr.appendChild(ttl); hdr.appendChild(cls);

    var list = document.createElement('ul');
    list.className = 'abk-sort-popup__list';

    btns.forEach(function (btn) {
      var active = btn.closest('li') && btn.closest('li').classList.contains('tag--active');
      var li = document.createElement('li');
      li.className = 'abk-sort-popup__item' + (active ? ' is-active' : '');
      var b = document.createElement('button'); b.type = 'button';
      var lbl = document.createElement('span'); lbl.textContent = btn.textContent.trim();
      var chk = document.createElement('span'); chk.className = 'abk-sort-popup__check';
      chk.setAttribute('aria-hidden', 'true');
      chk.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
      b.appendChild(lbl); b.appendChild(chk);
      b.addEventListener('click', function () {
        btn.click();
        list.querySelectorAll('.abk-sort-popup__item').forEach(function (el) { el.classList.remove('is-active'); });
        li.classList.add('is-active');
        setTimeout(closeSortPopup, 180);
      });
      li.appendChild(b); list.appendChild(li);
    });

    popup.appendChild(hdr); popup.appendChild(list);
    document.body.appendChild(overlay);
    document.body.appendChild(popup);
    window._abkSortPopup = popup;
    window._abkSortOverlay = overlay;
  }
  function openSortPopup() {
    buildSortPopup();
    var p = window._abkSortPopup, o = window._abkSortOverlay;
    if (!p) return;
    requestAnimationFrame(function () { p.classList.add('is-open'); if (o) o.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeSortPopup() {
    var p = window._abkSortPopup, o = window._abkSortOverlay;
    if (p) p.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ── Filter count ── */
  function updateFilterCount() {
    var el = qs('.abk-filter-count'); if (!el) return;
    var n = document.querySelectorAll('.tag--remove').length;
    el.textContent = n || ''; el.classList.toggle('is-hidden', !n);
  }

  /* ── Product page: main form scoping ── */
  function getMainProductForm() {
    var mainSection = qs('[data-section-type="main-product"], #MainProduct, .main-product-section, section-main-product');
    if (mainSection) { var f = mainSection.querySelector('form[action*="/cart/add"]'); if (f) return f; }
    var mainContent = qs('main, #MainContent, [role="main"]');
    if (mainContent) {
      var forms = mainContent.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].querySelector('button[name="add"], input[name="add"]')) return forms[i];
      }
    }
    var buyButtons = qs('block-buy-buttons');
    if (buyButtons) { var bf = buyButtons.querySelector('form[action*="/cart/add"]'); if (bf) return bf; }
    return qs('form[action*="/cart/add"]');
  }
  function getVariantId() {
    var form = getMainProductForm(); if (!form) return null;
    var i = form.querySelector('input[name="id"]'); if (i && i.value) return i.value;
    var s = form.querySelector('select[name="id"]'); if (s && s.value) return s.value;
    return null;
  }
  function syncATC() {
    var btn = qs('[data-abk-add-to-cart]'); if (!btn) return;
    var vid = getVariantId();
    var sp = btn.querySelector('span');
    var icon = btn.querySelector('svg');
    var form = getMainProductForm();
    var mb = form ? form.querySelector('button[name="add"]') : null;
    if (!vid) {
      btn.disabled = true; btn.dataset.abkMode = 'unavailable';
      if (sp) sp.textContent = 'Unavailable';
      if (icon) icon.style.display = 'none';
      return;
    }
    var soldOut = mb && mb.disabled;
    if (soldOut) {
      btn.disabled = false; btn.dataset.abkMode = 'notify';
      if (icon) icon.style.display = 'none';
      if (sp) sp.textContent = 'Notify Me';
      btn.style.background = '#111'; btn.style.color = '#fff';
    } else {
      btn.disabled = false; btn.dataset.abkMode = 'atc';
      if (icon) icon.style.display = '';
      if (sp) sp.textContent = 'Add to Cart';
      btn.style.background = ''; btn.style.color = '';
    }
  }
  function doAddToCart(btn) {
    if (btn.dataset.abkMode === 'notify') {
      var vid = getVariantId();
      var doranDiv = qs('[data-dr="back-in-stock-inline-button"]');
      if (doranDiv && vid) doranDiv.setAttribute('data-selected-variant-id', vid);
      var doranBtn = doranDiv ? doranDiv.querySelector('button, a, [role="button"]') : null;
      if (doranBtn) { doranBtn.click(); return; }
      if (window.$bpDoran && typeof window.$bpDoran.openPopup === 'function') { window.$bpDoran.openPopup(vid); return; }
      if (doranDiv) { doranDiv.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }
    var vid = getVariantId();
    var qi = qs('.abk-product-qty input');
    var qty = Math.max(1, parseInt(qi ? qi.value : '1', 10) || 1);
    if (!vid || btn.disabled || btn.dataset.abkMode === 'unavailable') return;
    btn.disabled = true;
    var orig = btn.innerHTML;
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: qty }] })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        btn.innerHTML = '<span>✓ Added</span>';
        setTimeout(function () { btn.innerHTML = orig; syncATC(); }, 1400);
      })
      .catch(function () {
        btn.innerHTML = '<span>Try Again</span>';
        setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 1500);
      });
  }

footer.addEventListener('click', function (e) {
  var ae = e.target.closest('[data-abk-action]');
  if (ae) {
    var a = ae.dataset.abkAction;
    if (a === 'search') return doSearch(e);
    if (a === 'menu') return doMenu();
    if (a === 'account'){
      /* Close others first, toggle account */
      if(_activeAction==='account'){setActiveBtn(null);}
      else{closeAllExcept('account');setActiveBtn('account');}
      return doAccount();
    }
    if (a === 'filter'){
      /* Close others first */
      closeAllExcept('filter');
      setActiveBtn(_activeAction==='filter'?null:'filter');
      return doFilter();
    }
    if (a === 'cart') return doCart(); /* cart never stays highlighted */
    if (a === 'sort') return openSortPopup();
    return;
  }

    var qe = e.target.closest('[data-qty-action]');
    if (qe) {
      var inp = qs('.abk-product-qty input'); if (!inp) return;
      inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + (qe.dataset.qtyAction === 'increase' ? 1 : -1));
      return;
    }
    var ab = e.target.closest('[data-abk-add-to-cart]');
    if (ab) doAddToCart(ab);
  });

  /* ── Page-specific setup ── */
  if (pageType === 'product') {
    document.addEventListener('variant:change', syncATC);
    var mainForm = getMainProductForm();
    var vi = mainForm ? mainForm.querySelector('input[name="id"]') : null;
    if (vi) {
      var vtimer;
      new MutationObserver(function () { clearTimeout(vtimer); vtimer = setTimeout(syncATC, 60); })
        .observe(vi, { attributes: true, attributeFilter: ['value'] });
      if (mainForm) {
        mainForm.addEventListener('change', function (e) {
          if (e.target.name === 'id' || e.target.closest('variant-select') || e.target.closest('select[name="id"]')) syncATC();
        });
      }
    }
    var atcObserver = new MutationObserver(function () { syncATC(); });
    function watchMainBtn() {
      var form = getMainProductForm();
      var mb = form ? form.querySelector('button[name="add"]') : null;
      if (mb) atcObserver.observe(mb, { attributes: true, attributeFilter: ['disabled'] });
    }
    syncATC();
    setTimeout(syncATC, 300);
    setTimeout(syncATC, 800);
    setTimeout(watchMainBtn, 500);
    if ('requestIdleCallback' in window) requestIdleCallback(syncATC);
  }

  if (pageType === 'collection') {
    var fat = qs('.tag-list--active-tags');
    if (fat) new MutationObserver(updateFilterCount).observe(fat, { childList: true, subtree: true });
  }

  /* ── Cart count sync ── */
  document.addEventListener('CartDrawer:open', fetchCartCount);
  var cartSyncTimer;
  document.addEventListener('cart:updated', function () {
    clearTimeout(cartSyncTimer);
    cartSyncTimer = setTimeout(fetchCartCount, 120);
  });

  /* ── Deferred init ── */
  if ('requestIdleCallback' in window) {
    requestIdleCallback(function () {
      fetchCartCount();
      if (pageType === 'collection') updateFilterCount();
    });
  } else {
    setTimeout(function () {
      fetchCartCount();
      if (pageType === 'collection') updateFilterCount();
    }, 300);
  }

})();
